module.exports = __webpack_public_path__ + "img/2026big4.0551cb0d.png";